import registerWithErrorBoundary from '@utils/registerWithErrorBoundary';

import Jobs from '@components/pages/Jobs/index';

registerWithErrorBoundary({
  Jobs,
});
